import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
export { GrowthBook } from '@growthbook/growthbook';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var GrowthBookContext = /*#__PURE__*/React.createContext({});

function run(exp, growthbook) {
  if (!growthbook) {
    return {
      value: exp.variations[0],
      variationId: 0,
      inExperiment: false,
      hashAttribute: exp.hashAttribute || "id",
      hashValue: ""
    };
  }

  return growthbook.run(exp);
}

function useExperiment(exp) {
  var _React$useContext = React.useContext(GrowthBookContext),
      growthbook = _React$useContext.growthbook;

  return run(exp, growthbook);
}

var withRunExperiment = function withRunExperiment(Component) {
  // eslint-disable-next-line
  var withRunExperimentWrapper = function withRunExperimentWrapper(props) {
    return /*#__PURE__*/React.createElement(GrowthBookContext.Consumer, null, function (_ref) {
      var growthbook = _ref.growthbook;
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        runExperiment: function runExperiment(exp) {
          return run(exp, growthbook);
        }
      }));
    });
  };

  return withRunExperimentWrapper;
};

withRunExperiment.displayName = "WithRunExperiment";

var GrowthBookProvider = function GrowthBookProvider(_ref2) {
  var children = _ref2.children,
      growthbook = _ref2.growthbook;

  // Tell growthbook how to re-render our app (for dev mode integration)
  // eslint-disable-next-line
  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      _ = _React$useState2[0],
      setRenderCount = _React$useState2[1];

  React.useEffect(function () {
    if (!growthbook || !growthbook.setRenderer) return;
    growthbook.setRenderer(function () {
      setRenderCount(function (v) {
        return v + 1;
      });
    });
    return function () {
      growthbook.setRenderer(function () {// do nothing
      });
    };
  }, [growthbook]);
  return /*#__PURE__*/React.createElement(GrowthBookContext.Provider, {
    value: {
      growthbook: growthbook
    }
  }, children);
};

export { GrowthBookContext, GrowthBookProvider, useExperiment, withRunExperiment };